import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopButton = _resolveComponent("PopButton")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("div", {
      id: "popRow",
      style: _normalizeStyle({ borderColor: _ctx.getColor() }),
      class: _normalizeClass({ blinkBackgroundAnimation: _ctx.getWinner() })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateObj?.ButtonStates, (item, index) => {
        return (_openBlock(), _createBlock(_component_PopButton, {
          buttonID: {rowID: _ctx.rowID, buttonID: index},
          key: index,
          rowState: _ctx.stateObj,
          buttonState: item
        }, null, 8, ["buttonID", "rowState", "buttonState"]))
      }), 128))
    ], 6)
  ]))
}